import { render, staticRenderFns } from "./LegalPageLayout.vue?vue&type=template&id=0d626e24&scoped=true"
import script from "./LegalPageLayout.vue?vue&type=script&lang=js"
export * from "./LegalPageLayout.vue?vue&type=script&lang=js"
import style0 from "./LegalPageLayout.vue?vue&type=style&index=0&id=0d626e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d626e24",
  null
  
)

export default component.exports